
/* ADD DON'T ASK AGAIN VARIABLE TO LOCALE STORAGE */
$(document, '.mdl-wrap').on('click', '.js-confirm-delete-video-from-playlist-btn', function(){
    const askAgainCheckbox = $('.js-delete-from-playlist-ask-again-input');

    if(askAgainCheckbox.prop('checked') === true){
        setAskAgainToTrueToLocalStorage();
    }
});

function setAskAgainToTrueToLocalStorage(){
    localStorage.setItem('deleteVideoFromPlayListWithoutConfirm', 'true');
}

/* DELETE SINGLE VIDEO FROM PLAYLIST */
$(document, '.mdl-wrap').on('click', '.js-delete-video-from-playlist-btn', function(){
    const videoID = $(this).data('video-id');
    $('.js-delete-video-from-playlist-input').val(videoID);

    if (localStorage.getItem('deleteVideoFromPlayListWithoutConfirm') !== 'true') {
        $('#mdl-playlist-delete-video').addClass('active');
    } else {
        $('.js-delete-video-from-playlist-form').submit();
    }
});

/* DELETE PLAYLIST */
function addPlaylistIDToDeleteForm(){
    $('.js-playlist-id-input').val(playlistID);
}

runIfElementExist(addPlaylistIDToDeleteForm, '.js-playlist-id-input');
